const getChartPoints = product => {
  const isReducedSet = [2, 4].includes(product)

  const pts = isReducedSet
    ? ['max_rev', 'vw_optimal', 'clients_price']
    : ['max_rev', 'max_prof', 'vw_optimal', 'clients_price', 'break_even']

  const tts = isReducedSet ? ['max_rev'] : ['max_rev', 'max_prof', 'break_even']

  return { pts, tts }
}

const generateProfitAndRevenueModel = ({ id, product, period, answer, chartMode }) => {
  const { pts, tts } = getChartPoints(product)
  const plots = answer?.plots
  const pointsOfInterest = answer?.pointsOfInterest

  return {
    x: plots?.['xpos'],
    yText: [2, 4].includes(product) ? 'REVENUE' : 'REVENUE/PROFIT',
    yPrefix: '$',
    yLimit: [5, 6].includes(product) ? answer?.profLim?.[`p${period}`] : null,
    graph1: plots?.['revenue_curve_plot']?.[`p${period}`],
    graph2: [2, 4].includes(product) ? null : plots?.profit_curve_plot[`p${period}`],
    p: pointsOfInterest?.[`p${period}`],
    points: pts,
    tooltipsFor: tts,
    tooltipsVal: answer?.['probCallout'] || null,
    maximized: 40,
    product,
    position: `${id}_profit_revenue`,
    chartMode,
    print: false,
    gridOpacity: 0.2
  }
}

export const generateInfographicWestendorpModel = ({ id, answer, period }) => {
  const plots = answer?.plots
  const pointsOfInterest = answer?.pointsOfInterest

  return {
    x: plots?.['xpos_VW'],
    backgroundColor: '#384854',
    plots,
    points: pointsOfInterest?.[`p${period}`],
    panel: true,
    print: false,
    percentage: true,
    yText: 'PERCENT',
    yPrefix: '',
    gridOpacity: 0.2,
    position: `${id}_product_westendorp`
  }
}

export const generateInfographicPurchaseProbabilityModel = ({ id, answer, period }) => {
  const plots = answer?.plots
  const pointsOfInterest = answer?.pointsOfInterest
  const areas = answer?.areas

  return {
    x: plots?.['xpos'],
    maximized: 30,
    graph1: plots?.['probability_curve_plot'],
    graph2: null,
    yText: 'PROBABILITY',
    yPrefix: '$',
    yLimit: 0,
    percentage: true,
    backgroundColor: '#4c5a65',
    tooltipsFor: ['max_prob'],
    tooltipsVal: answer?.['probCallout'] || null,
    infographic: true,
    p: pointsOfInterest?.[`p${period}`],
    position: `${id}_purchase_probability`,
    points: [],
    panel: true,
    print: false,
    areas: areas,
    area: 'prob',
    bars:
      plots?.['probability_bars']?.[`p${period}`] ||
      (Array.isArray(plots?.['probability_bars']) && plots?.['probability_bars']) ||
      null,
    gridOpacity: 0.2
  }
}

export const generateInfographicPurchaseFrequencyModel = ({ id, answer, fqPeriod }) => {
  const plots = answer?.plots
  const pointsOfInterest = answer?.pointsOfInterest
  const areas = answer?.areas

  return {
    x: plots?.['xpos'],
    maximized: 30,
    graph1: plots?.['frequency_curve_plot']?.[`p${fqPeriod}`],
    graph2: null,
    yRaw: true,
    yText: 'FREQUENCY',
    yPrefix: '$',
    yLimit: 0,
    backgroundColor: '#4c5a65',
    tooltipsFor: ['max_freq'],
    tooltipsVal: answer?.['freqCallout']?.[`p${fqPeriod}`] || null,
    freqPeriod: fqPeriod,
    p: pointsOfInterest?.[`p${fqPeriod}`],
    points: [],
    position: `${id}_purchase_frequency`,
    print: false,
    panel: true,
    infographic: true,
    areas: areas,
    area: 'freq',
    bars:
      plots?.['frequency_bars']?.[`p${fqPeriod}`] ||
      (Array.isArray(plots?.['frequency_bars']) && plots?.['frequency_bars']) ||
      null,
    gridOpacity: 0.2
  }
}

export const generateInfographicProfitRevenueModel = ({ id, product, period, answer, chartMode }) => {
  return {
    ...generateProfitAndRevenueModel({ id, product, period, answer, chartMode }),
    backgroundColor: '#4c5a65'
  }
}

export const generateDefaultViewModel = ({ id, product, period, answer, chartMode }) => {
  const plots = answer?.plots
  const pointsOfInterest = answer?.pointsOfInterest

  const defaults = {
    gridOpacity: 0.2,
    backgroundColor: '#FFFFFF'
  }

  if (product !== 1) {
    return {
      ...defaults,
      ...generateProfitAndRevenueModel({ id, product, period, answer, chartMode })
    }
  }
  return {
    ...defaults,
    x: plots?.['xpos_VW'],
    plots: plots,
    points: pointsOfInterest?.['p0'],
    panel: true,
    print: false,
    percentage: true,
    yText: 'PERCENT',
    yPrefix: '',
    position: `${id}_product_westendorp`,
    oldVW: answer?.['oldVW'],
    chartMode
  }
}
